<section class="inactivity-warning" aria-labelledby="inactivity-warning-title">
  <h2 id="inactivity-warning-title">Inactivity Warning</h2>
  <p class="inactivity-warning__message" aria-atomic="true">
    You will be logged out in <strong>{{ formattedRemainingTime }}</strong>.
  </p>
  <div class="inactivity-warning__actions">
    <button type="button" class="inactivity-warning__logoff" (click)="onLogOff()">Log Off</button>
    <button type="button" class="inactivity-warning__continue" (click)="onContinueWorking()">Continue to Work</button>
  </div>
</section>
